// src/features/students/student.slice.ts
// UI state only — pagination, search, and institution filter.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { StudentUIState } from './student.types'

const initialState: StudentUIState = {
  currentPage: 0,
  pageSize: 10,
  searchQuery: '',
  selectedInstitutionId: null, // null = "All institutions"
}

const studentSlice = createSlice({
  name: 'studentUi',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
    },
    setSelectedInstitutionId: (state, action: PayloadAction<number | null>) => {
      state.selectedInstitutionId = action.payload
    },
    // When filter changes, reset to page 0 — call this at the dispatch call site
    resetPage: (state) => {
      state.currentPage = 0
    },
  },
})

export const {
  setCurrentPage,
  setPageSize,
  setSearchQuery,
  setSelectedInstitutionId,
  resetPage,
} = studentSlice.actions

export default studentSlice.reducer
